// extracted by mini-css-extract-plugin
export default {"echartsForEcharts":"ChartPreview_echartsForEcharts__qZpHw"};